import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { getUrlVars, errorHandler, getOAuth2SearchString } from "../../utils";
import { withStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AuthForm, AuthField } from '../../components/authForm';
import { USezpayAuthForm } from '../../components/authForm/USezpayAuthForm';
import { AuthBtn } from '../../components/global';
import { forgetPassword } from "../../APIs";
import { recoverPwd_styles } from "./styles";
import { isUSezpayRequest } from '../../utils/domainDetection';

export default withStyles(recoverPwd_styles)((props) => {
    const {
        classes,
    } = props;
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const methodStr = getUrlVars()["method"];
    const method = JSON.parse(decodeURIComponent(methodStr));
    const oauth2SearchStr = getOAuth2SearchString()
    const backUrl = "/login?" + oauth2SearchStr;
    const onSend = async () => {
        setLoading(true);
        try {
            await forgetPassword(method.username, { oauth2_query_string: oauth2SearchStr});
            setLoading(false);
            if (method.phone_number && method.phone_number_verified && !method.email) {
                history.push("/forgetpassword?" + oauth2SearchStr)
            } else {
                history.push(backUrl)
            }
            
        } catch(err) {
            setLoading(false);
            errorHandler(err);
        }
        
    }
    
    // Determine branding based on redirect_uri
    const isUSezpay = isUSezpayRequest();
    const FormComponent = isUSezpay ? USezpayAuthForm : AuthForm;

    return (
        <FormComponent title={"FORGOT YOUR PASSWORD?"}>
            {method.phone_number && method.phone_number_verified ?
                <AuthField label={"Phone"}
                    value={method.phone_number}
                    disabled/>
            : null}
            {method.email && method.email_verified ?
                <AuthField label={"Email"}
                    value={method.email}
                    disabled/>
            :null}
            <div className={classes.button}>
            {loading ?
                <CircularProgress color="secondary" /> :
                <AuthBtn variant="contained"
                    color="primary"
                    onClick={onSend}
                    style={isUSezpay ? { backgroundColor: '#d9b97f', color: '#fff' } : {}}>
                    {method.email && method.email_verified &&
                    method.phone_number && method.phone_number_verified ?
                        "SEND VERIFICATION TO EMAIL" :
                        "SEND VERIFICATION"
                    }
                </AuthBtn>
            }
                <AuthBtn variant="contained"
                    onClick={() => history.push(backUrl)}
                    style={isUSezpay ? { backgroundColor: '#d9b97f', color: '#fff' } : {}}
                >
                    CANCEL
                </AuthBtn>
            </div>

        </FormComponent>
    );
})

